import { render, staticRenderFns } from "./MspAppFooter.vue?vue&type=template&id=4bf3199d"
import script from "./MspAppFooter.vue?vue&type=script&lang=js"
export * from "./MspAppFooter.vue?vue&type=script&lang=js"
import style0 from "./MspAppFooter.vue?vue&type=style&index=0&id=4bf3199d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports